var render = function render(){var _vm=this,_c=_vm._self._c;return _c('assets-library',{ref:"assets",attrs:{"tip":"上传图片大小不超过2M","scroll-height":"auto","limit":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }